export * from './ps-table.component';
